import angular from 'angular';
import dataManagementUsersControllers from 'data_management/users/usersControllers';
import 'angular-breadcrumb';
import 'ng-table';
import {accessLevels} from '../services/accessLevels';

/**
 * @ngdoc overview
 * @name dataManagementModule
 * @description
 * # dataManagementModule
 * Module for managing the data management of: users.
 */
const dataManagementModule = angular.module('dataManagementModule', [
    'dataManagementModule.dataManagementUsersControllers',
    'ncy-angular-breadcrumb',
    'ngTable'
]);

dataManagementModule.config(['$stateProvider', function ($stateProvider) {
    'use strict';
    $stateProvider
        .state('appsoup.data_management', {
            abstract: true,
            url: '/data-management',
            ncyBreadcrumb: {
                label: 'MODULES.DATA_MANAGEMENT.TITLE'
            },
            template: '<ui-view/>'
        })
        .state('appsoup.data_management.users', {
            url: '/users',
            templateUrl: 'views/data_management/users/users.tpl.html',
            controller: 'DataManagementUsersListController',
            ncyBreadcrumb: {
                label: 'MODULES.USERS.TITLE'
            },
            accessLevel: accessLevels.data_management_users
        })
        .state('appsoup.data_management.userEdit', {
            url: '/users/edit/:userId/:appId',
            templateUrl: 'views/data_management/users/user.tpl.html',
            controller: 'DataManagementUserPageController',
            ncyBreadcrumb: {
                label: 'MODULES.USERS.EDIT',
                parent: 'appsoup.data_management.users'
            },
            menuActive: 'appsoup.data_management.users',
            accessLevel: accessLevels.data_management_users
        });
}]);

export default dataManagementModule;
